var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h1',{staticClass:"center"},[_vm._v("home "+_vm._s(_vm.user && _vm.user.defaultCurrency && _vm.user.defaultCurrency.symbol))])])}
var staticRenderFns = []

export { render, staticRenderFns }